module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library1.2d7acc85.jpg";